import { CopyTextField } from "@hire/components/CopyTextField";

interface Props {
  value: string;
}

export const CopyableField = ({ value }: Props): React.ReactElement => {
  return <CopyTextField value={value} level="secondary" />;
};
